import { render, staticRenderFns } from "./VSuggestionForm.vue?vue&type=template&id=f2ded58a&"
import script from "./VSuggestionForm.vue?vue&type=script&lang=ts&"
export * from "./VSuggestionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports